import { CreatePipelineSelectDestinationTypeWizardData } from '../interfaces/create-pipeline-destination-type-step-wizard-data';
import { SELECT_DESTINATION_TYPE_CACHE_DEFAULT_STATE } from '../../../../../destinations/SelectDestinationType/cache/constants';
import { SelectDestinationTypeCacheState } from '../../../../../destinations/SelectDestinationType/cache/interface';
import { DESTINATION_LIST_REDUCER_DEFAULT_STATE } from '../../../../../destinations/DestinationList/cache/constants';

export function CreatePipelineDestinationTypeStepWizardDataFactory(
  data: object
): CreatePipelineSelectDestinationTypeWizardData {
  return {
    loadingPageData: false,
    apiError: null,
    configureNewDestination:
      'configureNewDestination' in data ? !!data.configureNewDestination : false,
    createNewDestinationPageData:
      'createNewDestinationPageData' in data
        ? (data.createNewDestinationPageData as SelectDestinationTypeCacheState)
        : SELECT_DESTINATION_TYPE_CACHE_DEFAULT_STATE,
    existingDestinationPageData: DESTINATION_LIST_REDUCER_DEFAULT_STATE
  };
}
